<template>
    <div>
        <div v-if="hasItems" class="ml-0 lg:-ml-4">
            <div  v-for="timelineItem in timelineItems" :key="timelineItem.id" >
                <div  v-if="timelineItem.content" :class="['pl-6 relative '  , (timelineItem != timelineItems[timelineItems.length-1]) ? 'ml-6 border-l-2 border-blue-500 pb-2' : 'last-dot ' ]" >
                    <div class="absolute -ml-8">
                        <svg  width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <circle cx="7" cy="7" r="6" :fill="timelineItem.colour"
                                :stroke="timelineItem.colour"/>
                        </svg>
                    </div>
          
                        <div class="text-sm text-gray-700 text-left text-semibold" style="text-transform: capitalize;">{{timelineItem.content}} <span :style="'color: '+timelineItem.colour+';'" class="text-semibold" v-if="timelineItem.location">{{' '+ timelineItem.location}} </span> </div>
                        <p  class="text-xs text-gray-500 text-left"  style="text-transform: capitalize;">{{timelineItem.time}}</p>
               
                </div>
            </div>
        </div>
        <div v-else>
            <h5>Sorry, there is no information.</h5>
            <h5>Please contact Freighthub for more details.</h5>
        </div>

    </div>
</template>

<script>
    export default {
        name: "GuestFreightMovement",
        props: ['timelineItems'],
        data() {  
            return {
                
            }
        },

        computed: {
            hasItems: function() {
                if (this.timelineItems && this.timelineItems.length > 0) {
                    return true;
                };
            },

        }
    }
</script>